import React from 'react';
import './Reviews.scss';

const Star = () => (
    <svg height="25" width="23" data-rating="2">
        <polygon points="9.9, 1.1, 3.3, 21.78, 19.8, 8.58, 0, 8.58, 16.5, 21.78" />
    </svg>
)

const Stars = ({ rating }) => {
    let stars = [];

    for (let i = 0; i < rating; i++) {
        stars.push(<div key={i} className={`star ${((i + 1) <= rating) ? 'active' : ''}`}><Star /></div>);
    }

    return <div className='stars'>{stars}</div>
}

const Reviews = ({ subtitle, reviews }) => {
    return (
        <div>
            <div className="reviews">
                {
                    reviews.map((review, i) => (
                        <div className="review" key={i}>
                            <b>{review.name}</b>
                            <Stars rating={review.rating} />
                            <p>{review.subject}</p>
                        </div>
                    ))
                }
            </div>
            <p className='reviewSubtitle'>{subtitle}</p>
        </div>
    )
}

export default Reviews;


// WEBPACK FOOTER //
// ./src/components/ui/Reviews/Reviews.js